import {
    NetworkCreateForm,
    NetworkUpdateForm,
    NetworkData,
    NetworkListResponse,
    NetworkResponse,
    NetworkStatus,
} from 'chaika-frontend-types/frontend-cms';

import { axios } from '@lib/axios';

const BASE_URL = '/api/network';

export class NetworkApi {
    public static async getList(): Promise<NetworkData[]> {
        const res = await axios.get<NetworkListResponse>(BASE_URL);

        return res.data.networks;
    }

    public static async getById(id: string): Promise<NetworkData> {
        const res = await axios.get<NetworkResponse>(`${BASE_URL}/${id}`);

        return res.data.network;
    }

    public static async create(network: NetworkCreateForm): Promise<void> {
        await axios.post(BASE_URL, { network });
    }

    public static async update(id: string, network: NetworkUpdateForm): Promise<void> {
        await axios.put(`${BASE_URL}/${id}`, { network });
    }

    public static async updateStatus(id: string, status: NetworkStatus): Promise<void> {
        await axios.put(`${BASE_URL}/${id}`, { network: { status } });
    }
}
